import React from "react";
import Collapse, { CollapsePanel } from "../ui/Collapse";
import "./GMBScoring.css";
import LockOverview from "./LockOverview";
import useLang from "../../i18n/useLang";
import content from "./content";

const TopIssues = ({ issues, hasFullAccess }) => {
  const t = content[useLang()].issues;

  if (!issues || issues.length === 0) {
    return (
      <div className="audit-section">
        <div className="audit-section__header">
          <span className="audit-section__badge audit-section__badge--green">0</span>
          <h4 className="audit-section__title">{t.title}</h4>
        </div>
        <p className="audit-section__empty">{t.empty}</p>
      </div>
    );
  }

  const visibleIssues = hasFullAccess ? issues : issues.slice(0, 3);

  return (
    <div className="audit-section">
      <div className="audit-section__header">
        <span className="audit-section__badge audit-section__badge--red">{issues.length}</span>
        <h4 className="audit-section__title">{t.title}</h4>
      </div>
      <Collapse>
        {visibleIssues.map((issue, i) => (
          <CollapsePanel
            header={issue.header}
            extra={<span className="audit-section__status audit-section__status--issue">{t.status}</span>}
            key={issue.header}
            defaultOpen={i === 0}
          >
            <p className="audit-section__content">{issue.content}</p>
          </CollapsePanel>
        ))}
      </Collapse>
      {!hasFullAccess && issues.length > 3 && (
        <LockOverview isIssue={true} issuesRemaning={issues.length - 3} />
      )}
    </div>
  );
};

export default TopIssues;
